/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectFolderDto
 */
export interface ProjectFolderDto {
    /**
     * 
     * @type {string}
     * @memberof ProjectFolderDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectFolderDto
     */
    name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProjectFolderDto
     */
    projectItemsCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProjectFolderDto
     */
    projectPortfolioVinsCount?: number;
}

export function ProjectFolderDtoFromJSON(json: any): ProjectFolderDto {
    return ProjectFolderDtoFromJSONTyped(json, false);
}

export function ProjectFolderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectFolderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'projectItemsCount': !exists(json, 'projectItemsCount') ? undefined : json['projectItemsCount'],
        'projectPortfolioVinsCount': !exists(json, 'projectPortfolioVinsCount') ? undefined : json['projectPortfolioVinsCount'],
    };
}

export function ProjectFolderDtoToJSON(value?: ProjectFolderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'projectItemsCount': value.projectItemsCount,
        'projectPortfolioVinsCount': value.projectPortfolioVinsCount,
    };
}


